import * as React from "react";
import { createRoot } from "react-dom/client";
import { Loader2 } from "lucide-react";
import "../styles/globals.css";

const LoadingDialog = () => {
    return (
        <div className="flex flex-col items-center justify-center h-screen w-full bg-white space-y-4 p-4">
            <div className="relative w-16 h-16">
                <img
                    src="../assets/icon-80.png"
                    alt="Logo"
                    className="w-full h-full object-contain"
                />
            </div>

            <div className="flex items-center space-x-2 text-slate-600">
                <Loader2 className="w-5 h-5 animate-spin text-blue-600" />
                <span className="font-medium text-sm">Processing...</span>
            </div>
        </div>
    );
};

/* global document, Office, HTMLElement */

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

Office.onReady(() => {
    root?.render(<LoadingDialog />);
});
